import {BreadCrumb, TablePaging, ReactSingleSelectServer } from "~/components";
import {Fragment, useState} from "react";
import {format} from "date-fns";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit, faCircleXmark} from "@fortawesome/free-solid-svg-icons";

const breadCrumbItem = [
    { text: "AI Chatbot Page", to: "/ai-chatbot/administrator", isActive: false },
    { text: "Support Case History", to: "", isActive: true },
];

function SupportCaseHistory() {
    const [reloadTable, setReloadTable] = useState(false);
    const [activeTab, setActiveTab] = useState("history");
    const [selected, setSelected] = useState(null);
    const tablePagingConfig = {
        columns: [
            {
                name: 'ID',
                width: '70px',
                className: 'fw-bold',
                key: 'SupportCaseId'
            },
            {
                name: 'CASE ID',
                width: '200px',
                className: 'fw-bold',
                key: 'CaseId',
                template: (row) => {
                    return (
                       <a href="#">{row.CaseId}</a>
                    )
                }

            },
            {
                name: 'CUSTOMER',
                width: '200px',
                className: 'fw-bold',
                key: "Customer",
                template: (row) => {
                    return (
                        <div className=" d-flex align-items-center text-body"
                             data-discover="true">
                            <div className="avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={row.CustomerAvatarUrl}/>
                            </div>
                            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.CustomerName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'SUPPORTER',
                width: '200px',
                className: 'fw-bold',
                key: "Supporter",
                template: (row) => {
                    return (
                        row.SupporterId ? (
                            <div className=" d-flex align-items-center text-body"
                                 data-discover="true">
                                <div className="avatar avatar-m">
                                    <img alt="avatar" className="rounded-circle" src={row.SupporterAvatarUrl}/>
                                </div>
                                <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.SupporterName}</p>
                            </div>
                        ) : (
                            <span className="fs-8-1 fw-bold">Pending</span>
                        )
                    )
                }
            },
            {
                name: 'CASE TYPE',
                width: '150px',
                key: 'CaseType'
            },
            {
                name: 'CASE STATUS',
                width: '150px',
                key: 'CaseStatus'
            },
            {
                name: 'CASE CONTACT TYPE',
                width: '200px',
                key: 'CaseContactType'
            },
            {
                name: 'CASE CONTACT TYPE',
                width: '200px',
                key: 'CaseContactType'
            },
            {
                name: 'SUBJECT',
                width: '200px',
                key: 'Subject'
            },
            {
                name: 'DESCRIPTION',
                width: '250px',
                key: 'Description'
            },
            {
                name: 'IS REJECT',
                width: '100px',
                key: 'IsReject',
                template: (row) => {
                    return (
                        row.IsReject && <span><FontAwesomeIcon icon={faCircleXmark}/></span>
                    )
                }
            },
            {
                name: 'REJECT REASON',
                width: '200px',
                key: 'RejectReason'
            },
            {
                name: 'PHONE NUMBER',
                width: '200px',
                key: 'PhoneNumber'
            },
            {
                name: 'CREATED DATE',
                width: '150px',
                key: 'CreatedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CreatedDate), "dd-MM-yyyy")}</span>
                    )
                }
            }
        ],
        url: "/support-cases/history/paged",
        tableKey: "TableSupportCaseHistory",
    }

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem} />
            <h2 className="text-bold text-body-emphasis mb-4">Support Case History</h2>

            <div>
                <div className="mb-3 nav nav-underline" role="tablist">
                    <div className="nav-item">
                        <a
                            className={`nav-link ${activeTab === "history" ? "active" : ""}`}
                            id="tab-history-tab"
                            role="tab"
                            aria-selected={activeTab === "history"}
                            onClick={() => setActiveTab("history")}
                            style={{ cursor: "pointer" }}
                        >
                            History
                        </a>
                    </div>

                    <div className="nav-item">
                        <a
                            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
                            id="tab-details-tab"
                            role="tab"
                            aria-selected={activeTab === "details"}
                            onClick={() => setActiveTab("details")}
                            style={{ cursor: "pointer" }}
                        >
                            Details
                        </a>
                    </div>
                </div>

                <div className="tab-content mt-3">
                    {activeTab === "history" && (
                        <div
                            className="tab-pane fade show active"
                            id="tab-history"
                            role="tabpanel"
                            aria-labelledby="tab-history-tab"
                        >
                            <TablePaging
                                tablePagingConfig={tablePagingConfig}
                                reloadTable={reloadTable}
                            />
                        </div>
                    )}

                    {activeTab === "details" && (
                        <div
                            className="tab-pane fade show active"
                            id="tab-details"
                            role="tabpanel"
                            aria-labelledby="tab-details-tab"
                        >
                            <div className="row">
                                <div className="col-sm-6 col-12">
                                    <span className="fs-8-1 fw-bold">Select case id</span>
                                    <ReactSingleSelectServer
                                        fetchUrl="/support-cases/ddl-user-case"
                                        value={selected}
                                        onChange={setSelected}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
}
export default SupportCaseHistory;